import { render, staticRenderFns } from "./CenterEditor.vue?vue&type=template&id=79b9690c&"
import script from "./CenterEditor.vue?vue&type=script&lang=ts&"
export * from "./CenterEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports